import { makeRequest } from 'utils/requestLogger';

export default (id, message_id) =>
    makeRequest('get', `/api/courses/${id}/load-message/${message_id}`);


// WEBPACK FOOTER //
// ./src/app/services/courses/loadChatMessage.js